import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { useAppState } from "./useReduxState"
import { getPageToFetch, getItemList } from "../Models/Client/RemoteData"
import { getFeedbackMessages } from "../Actions/API/Job/JobActions"
import { Result } from "../Models/Utility/Result"
import { getDefaultFeedbackParams } from "../Models/API/JobModel"
import { FetchState } from "../Models/Client/FetchState"
import { APIFeedbackMessage } from "../Models/API/JobFeedbackModel"

const filterByTask = (taskId: string, isLabelByCollaborator?: boolean) =>
    isLabelByCollaborator
        ? (message: APIFeedbackMessage) => message.labelerTaskId === taskId
        : (message: APIFeedbackMessage) => message.taskId === taskId
export const useFeedbackMessages = (
    jobId?: string,
    taskId?: string,
    isLabelByCollaborator?: boolean
): FetchState<APIFeedbackMessage[]> => {
    const dispatch = useDispatch()
    const conversations = useAppState(state => {
        if (!jobId) {
            return undefined
        }
        return state.api.jobs.jobIdToConversation[jobId]
    })

    useEffect(() => {
        const defaultParams = getDefaultFeedbackParams()
        const page = getPageToFetch(conversations, defaultParams)

        if (page >= 0 && jobId) {
            dispatch(getFeedbackMessages(jobId, defaultParams))
        }
    }, [dispatch, jobId, conversations])

    return useMemo(() => {
        if (conversations === undefined || conversations.list === undefined) {
            return undefined
        }
        const messages = getItemList(conversations)
        if (taskId !== undefined) {
            return Result.ok(
                messages.filter(filterByTask(taskId, isLabelByCollaborator))
            )
        }
        return Result.ok(messages)
    }, [conversations, isLabelByCollaborator, taskId])
}
